export const REG_TYPE2 = ["Both", "First", "Second"];
export const APPENDIX = [
  "appendix_1",
  "appendix_2",
  "appendix_3",
  "appendix_4",
  "appendix_5",
];
export const APPENDIX_2 = ["appendix_6"];
